import { API_URL } from "../config/connect";
import { throwResponseError } from '../utils/apiErrorHandler';

export async function getMyTariff() {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
        return null;
    }

    try {
        const response = await fetch(`${API_URL}/api/v1/subscription/current`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            return null;
        }

        return await response.json();
    } catch {
        return null;
    }
}

export async function activateTariff(tariffId) {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
        throw new Error("Unauthorized");
    }

    const response = await fetch(`${API_URL}/api/v1/subscriptions/upgrade`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tariff_id: tariffId }),
    });

    if (!response.ok) {
        await throwResponseError(response);
    }

    return await response.json();
}
